import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_COUNTRIES = 'SET_COUNTRIES';

const setCountries = payload => ({ type: SET_COUNTRIES, payload });

export const setCountriesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.COUNTRIES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var countries = {};
                    snapshot.forEach(function(country) {
                        var countryVal = country.val();
                        countries[countryVal.id] = countryVal.name;
                    });
                    dispatch(setCountries(countries));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setCountries(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setCountries(null));
        });
    };
};